import React from "react";
import { Modal, Input, Select, Button, Form, message, Col, Row } from "antd";

const { Option } = Select;

const AddNewPayment = ({ open, handleCancel }) => {
  const [form] = Form.useForm();

  const handleSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        console.log("Form values:", values);
        message.success("Payout request submitted successfully!");
        form.resetFields();
        handleCancel();
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  return (
    <Modal
      open={open}
      title={
        <span className="d-flex justify-content-center add-new-lead-heading">
          Request Payout
        </span>
      }
      onCancel={handleCancel}
      footer={[
        <Button
          key="submit"
          onClick={handleSubmit}
          className="add-new-customer-save-button"
        >
          Submit
        </Button>,
      ]}
    >
      <Form layout="vertical" form={form} className="mt-4">
        <div className="mb-4 modal-top-heading-text">
          <h4>Available Balance : ₹ 12000</h4>
        </div>

        <Row gutter={24}>
          <Col span={12}>
            <Form.Item name="amount">
              <Input
                placeholder="Enter Amount to Withdraw"
                className="add-new-customer-input"
              />
              <span className="add-new-customer-input-span">Amount</span>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="paymentMethod">
              <Select
                className="add-new-customer-input"
                placeholder="Net Banking"
              >
                <Option value="netBanking">Net Banking</Option>
                <Option value="upi">UPI</Option>
                <Option value="wallet">Wallet</Option>
              </Select>
              <span className="add-new-customer-input-span">
                Payment Method
              </span>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={24}>
          <Col span={12}>
            <Form.Item name="accountHolderName">
              <Input
                placeholder="Enter Holder Name"
                className="add-new-customer-input"
              />
              <span className="add-new-customer-input-span">
                Account Holder Name
              </span>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="bankName">
              <Input
                placeholder="Enter your Bank Name"
                className="add-new-customer-input"
              />
              <span className="add-new-customer-input-span">Bank Name</span>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={24}>
          <Col span={12}>
            <Form.Item name="accountNumber">
              <Input
                placeholder="Enter your Account Number"
                className="add-new-customer-input"
              />
              <span className="add-new-customer-input-span">
                Bank Account Number
              </span>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="reEnterAccountNumber">
              <Input
                placeholder="Enter your Account Number"
                className="add-new-customer-input"
              />
              <span className="add-new-customer-input-span">
                Re-enter Account Number
              </span>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={24}>
          <Col span={12}>
            <Form.Item name="ifscCode">
              <Input
                placeholder="Enter your IFSC Code"
                className="add-new-customer-input"
              />
              <span className="add-new-customer-input-span">IFSC Code</span>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="branchName">
              <Input
                placeholder="Enter Branch Name"
                className="add-new-customer-input"
              />
              <span className="add-new-customer-input-span">Branch Name</span>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default AddNewPayment;
